import { useRef, useState , useEffect } from "react";
import Config from "../../Config";


import goright from "../../go_right.png";
import myattach from "../../myattach.png";
import xmsg from "../../xmsg.png";
import ymsg from "../../ymsg.png";

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputDate from "../../helpers/InputDate";



import edit from "../../edit.png";
import trash from "../../trash.png";
import gozoom from "../../gozoom.png";
import Zoom from "./Zoom";
import MsgNew from "./MsgNew";
import InputText from "../../helpers/InputText";
import InputCombo from "../../helpers/InputCombo";
import ZoomR from "./ZoomR";
import QuickChat from "./QuickChat";
import MenuTable from "../../helpers/MenuTable";
import SortBy from "../../helpers/SortBy";
import AppContext from "../../AppContext";
import Thread from "./Thread";



function Received(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        nadawca: '',    
        data_od: '', 
        data_do: '', 
        temat: '', 
        odczytana: '_x_', 

        moje: '1',

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true, 
    });
    const [tab, setTab] = useState(null);

    const tabRef = useRef(0); //do druku




    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_msg,received', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

      //  console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {
        setFilterParam({
            nadawca: '',   
            data_od: '', 
            data_do: '',                   
            temat: '',        
            odczytana: '_x_',   
            
            moje: '1',
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },

            limit: 50,
            page: 1,
            show: true, 
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    
    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();
        return <div>
            ...
        </div>
    }


 

    
    
    
    
    const changeView = (e ) => {
                var v = e.target.getAttribute('v');
                var id = e.target.getAttribute('id');
    
                setView({...view, ["v"]:v, ["id"]:id });
        }
    
    
    const onBack = () => {                 
            setView({...view, ["v"]:"list", ["id"]:-1 });             
        }

    const onSukcess = () => {
           
            setView({...view, ["v"]:"list", ["id"]:-1 }); 
            getTab();
        }
    
        



        



        if(refreshView != props.userData.refreshView)
            {         
                setRefreshView( props.userData.refreshView);
                setTab(null);
                onBack();
            }
        




           
        if(view.v == 'history')
            {          
                   var tmp = null;

                   for(var k=0; k<tab.length; k++)
                   {
                      if(tab[k].id == view.id) {  tmp = tab[k]; break; }
                   }

                   return <Thread   userData={props.userData}  mainView={props.mainView} id={view.id} goBack={onBack}  row={tmp} />             
            }


        if(view.v == 'edit')
            {          
                   var tmp = null;

                   for(var k=0; k<tab.length; k++)
                   {
                      if(tab[k].id == view.id) {  tmp = tab[k]; break; }
                   }

                   return <ZoomR  userData={props.userData}  mainView={props.mainView} id={view.id} goBack={onBack}  row={tmp} />             
            }

        if(view.v == 'new')
            {  
                return <MsgNew  userData={props.userData}  mainView={props.mainView} id={view.id} goBack={onBack} onSukcess={onSukcess}  />  
            }


            


            const itemsTakNie = [
                { v: '_x_', title: '- - -' },
                { v: '0', title: 'Nie' },        
                { v: '1', title: 'Tak' },         
            ];      



            var sortList = [                
                {column: "created_at", name: "Data"  },         
                {column: "nadawca", name: "Nadawca"  },
                {column: "tytul", name: "Tytuł"  },
        ]           

        
             

        return (

            <div className="view_content"  >
          

                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                    <div className="filter_controll">   
                        <label>Widok: </label>                             
                        <InputCombo items={[ {v:'_x_',title:'Wszystkie'},{ v: '1', title:'Tylko kierowane dla mnie'} ]}   userData={props.userData} value={filterParam.moje}   valChange={valChangeListener} goNext={goNextNew} name="moje" placeholder={"Moje: "}   />
                    </div>  
                  
                    <div className="filter_controll">   
                        <label>Temat: </label>                             
                        <InputText   userData={props.userData} value={filterParam.temat}   valChange={valChangeListener} goNext={goNextNew} name="temat" placeholder={"Temat: "}   />
                    </div>  


                    <div className="filter_controll">   
                        <label>Nadawca (nazwisko, imię, ...): </label>                             
                        <InputTextAlpha   userData={props.userData} value={filterParam.nadawca}   valChange={valChangeListener} goNext={goNextNew} name="nadawca" placeholder={"Nadawca: "}   />
                    </div>  

               
                    <div className="filter_controll">   
                      <label>Odczytana: </label>                             
                      <InputCombo  items={itemsTakNie}  userData={props.userData}  mainView={props.mainView}  value={filterParam.odczytana}   valChange={valChangeListener} goNext={goNextNew} name="odczytana" placeholder={" "}   />
                    </div> 


                    <div className="filter_controll filter_merge">   
                        <label>Data (od dnia / do dnia): </label>      <br/>                       
                        <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                        <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                    </div> 



                    <div className="filter_btn">
                       <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                        <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                    </div>

                  </div>
                } 


              


                <div className="bg_center">

                    
                    <div className="table_widget">                             
                              <InputPagger  filter={filterParam}  onChange={onChangePagger}  />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                    </div>

                <div className="scorll_x">
                    <table className="table" ref={tabRef}>
                                       
                                        <tbody>
                                            {
                                                tab.map(  (row, ix) => {


                                                    
                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";


                                                    if(row.odczytana == 0)
                                                    {
                                                            rowStyle = rowStyle + " noRead "
                                                    }


                                                    var tresc = row.tresc;
                                                    if(tresc.length > 30) tresc = tresc.substring(0, 30) + " ...";


                                                    return <tr className={rowStyle} key={ix} >
                                                    <td className="gocenter">{ix+1}</td>   

                                                    <td>  <span  className="link_normal" onClick={changeView} v="edit" id={row.id} >{row.nadawca.nazwa}</span> <QuickChat id={row.nadawca.id}  title={row.nadawca.nazwa} mainView={props.mainView} userData={props.userData} /> </td>                                                                                                                                  


                                                    <td className="link_normal" onClick={changeView} v="edit" id={row.id} >  <span  className="link_normal" onClick={changeView} v="edit" id={row.id} > {row.tytul} </span>
                                                        {
                                                            row.zalczniki.length > 0 &&
                                                            <span>&nbsp;<img src={myattach} title="Wiadomość zawiera załącznik" />&nbsp;</span>
                                                        }
                                                    </td>                                                                                          
                                                                                                                                                                                  
                                                    
                                                    <td className="goleft">{tresc}</td>

                                                    <td className="gocenter">{row.czas}</td>

                                                    <MenuTable>
                                                        <ul>
                                                            <li  title="Podgląd"  onClick={changeView} v="edit" id={row.id}  >pokaż</li>
                                                            <li title="Podgląd"  onClick={changeView} v="history" id={row.id}>pokaż cały wątek</li>
                                                        </ul>
                                                    </MenuTable>        

                                                    
                                                </tr>

                                                } )
                                            }
                                        </tbody>
                    </table>
               </div>


                </div>

            </div>


            )
}



export default Received;